
import React from 'react';
import type { Moment } from 'moment';
import { useTranslation } from 'react-i18next';

import type { SearchForumHit } from '../../../types';

export interface SearchForumHitHeaderProps {
  entityType: SearchForumHit['entity_type'][0];
  createdDate: Moment;
}

const SearchForumHitHeader: React.FC<SearchForumHitHeaderProps> = (props) => {
  const { entityType, createdDate } = props;

  const { t } = useTranslation('translation', { keyPrefix: 'components.search_forum.results.hit' });

  const formattedCreatedDate = createdDate.format('DD-MM-YYYY');

  return (
    <header className="SearchForum__Hit__header">
      <span className="SearchForum__Hit__header__label">
        {t(`${entityType}.label`)}
      </span>
      <time className="SearchForum__Hit__date" dateTime={formattedCreatedDate}>
        {formattedCreatedDate}
      </time>
    </header>
  );
};

export default SearchForumHitHeader;
